module.exports = __webpack_public_path__ + "img/Diego Losada.ea99bf75.jpg";